import { render, staticRenderFns } from "./pesoParaLaEdadNinas2a5A.vue?vue&type=template&id=59c64ec7&scoped=true&"
import script from "./pesoParaLaEdadNinas2a5A.vue?vue&type=script&lang=js&"
export * from "./pesoParaLaEdadNinas2a5A.vue?vue&type=script&lang=js&"
import style0 from "./pesoParaLaEdadNinas2a5A.vue?vue&type=style&index=0&id=59c64ec7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c64ec7",
  null
  
)

export default component.exports